

export const Button2 = ({label="Button", clickHandler, amount}) =>{
    return (
        <button className="button2" onClick={()=>clickHandler(amount)}>
            {label}
        </button>
    )
}